import api from './api';

export const gitHistoryApi = {
  getCommitHistory: async (pageNum = 1, pageSize = 20) => {
    const response = await api.get(
      `/api/commits?pageNum=${pageNum}&pageSize=${pageSize}`,
    );
    if (!Array.isArray(response.data?.commits))
      throw new Error('变更记录返回结果不完整，请重试');
    const {
      commits,
      total,
      pageNum: currentPage,
      pageSize: currentPageSize,
      totalPages,
    } = response.data;
    return {
      history: commits.map((commit) => ({
        hash: String(commit.hash ?? ''),
        message: commit.message || '',
        author: commit.author || '作者未提供',
        date: commit.date || null,
      })),
      total,
      currentPage,
      pageSize: currentPageSize,
      totalPages,
    };
  },
};
